import { connect } from 'react-redux'
import Addable from '../Components/Addable'
import { mapStateToPropsAddable } from '../Utils/mapToProps'

export default connect(
    mapStateToPropsAddable
)(Addable)
